var version = '0.6.4';
export { version };
//# sourceMappingURL=version.js.map